module.exports = __webpack_public_path__ + "static/Muli-Light-e36c105441f99b652620ed69dff1b38a.woff";